export function getBaseOrganizationsForConfig(organizations) {
  return (organizations ?? []).filter((org) => {
    const orgId = Number(org.value ?? org.id);
    if (!Number.isFinite(orgId) || orgId <= 0) return false;

    const basicId = Number(org.basic_id ?? org.basic ?? org.basicOrganization);
    if (!Number.isFinite(basicId) || basicId <= 0) return false;

    return orgId === basicId;
  });
}
